import { render, staticRenderFns } from "./MusicEditor.vue?vue&type=template&id=6808774d&scoped=true&"
import script from "./MusicEditor.vue?vue&type=script&lang=js&"
export * from "./MusicEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808774d",
  null
  
)

export default component.exports